import { jsonProperty, Serializable } from "ts-serializable";
import Unit from "../unit/Unit";

class AgendaMesDiaHorario extends Serializable{
    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    agendaId: string | null = null;

    @jsonProperty(String, null)
    turnoDiaId: string | null = null;

    @jsonProperty(String, null)
    data: string | null = null;

    @jsonProperty(String, null)
    horaInicio: string | null = null;

    @jsonProperty(String, null)
    horaFim: string | null = null;

    @jsonProperty(Number, null)
    duracaoMinutos: number | null = null;

    @jsonProperty(String, null)
    unidadeAtendimentoId: string | null = null;

    @jsonProperty(Unit, null)
    unit: Unit | null = null;

    @jsonProperty(Boolean, null)
    inativo: boolean = false;

    @jsonProperty(Boolean, null)
    ativavel: boolean = false;

}

export default AgendaMesDiaHorario;